



































import {
    State
} from 'vuex-class'
import * as firebase from 'firebase'

import HelloWorld from "@/components/HelloWorld.vue";
import Sidebar from "@/components/Sidebar.vue";
import { Vue, Component } from 'vue-property-decorator'
import {UserInterface} from "@/models/User";

@Component({
    data(){
        return{
            drawer:false
        }
    },

    components:{
        // eslint-disable-next-line vue/no-unused-components
        HelloWorld, Sidebar
    },

})
export default class Admin extends Vue {
    @State(state => state.auth.user) user: any;
    @State(state => state.auth.fullUser) fullUser: UserInterface;


    public async BindUsers(){
        await this.$store.dispatch('bindUsers')
    }
    public async BindCategories(){
        await this.$store.dispatch('bindCategories')
    }
    public async BindSubCategories(){

        await this.$store.dispatch('bindSubCategory')
    }
    public async BindClases(){
        await this.$store.dispatch('bindClases', 'desc')
    }

  

    created(){
        firebase.auth().onAuthStateChanged((user) =>{
            if (user){
                this.$store.dispatch('autoSignIn', user);
                this.$store.dispatch('bindUserDetails', user.uid)
            }
        });

        this.BindUsers();
        this.BindCategories();
        this.BindSubCategories();
        this.BindClases();
        this.$store.dispatch('bindAvatars');
        this.$store.dispatch('bindPictionary', 'desc');
        this.$store.dispatch('bindCategoryVideo');
        this.$store.dispatch('bindVideo');
        this.$store.dispatch('bindSoupLettersCategories');
        this.$store.dispatch('bindSoupLetters', 'asc');
    }
}
